import { IPointBasicForm } from './types';

export const defaultValues: IPointBasicForm = {
  name: '',
  description: '',
  address: '',
  status: 'Active',
  latitude: null,
  longitude: null,
  categories: [],
  brand: null,
  isValidLocation: false,
};
